<template>
    <div class="sc-detail-body">
        <div class="sc-meta" style="font-size: 14px; color: #3b4452">
            {{ $t("달력에 표시된 날에는 이 스케줄이") }} <b>{{ $t("실행되지 않습니다.") }}</b>
        </div>

        <ExceptionCalendar :exceptions="detail.exceptConfig" />

        <div v-if="sortedExceptions.length" class="sc-except-grid is-compact">
            <div
                v-for="item in sortedExceptions"
                :key="item.exceptDt"
                class="sc-except-item"
                :class="{ 'is-off': item.enabled === 'N' }"
            >
                <span class="d">{{ formatDate(item.exceptDt) }}</span>
                <span class="n" :title="item.exceptName">{{ item.exceptName }}</span>
            </div>
        </div>
        <div v-else class="sc-meta">{{ $t("등록된 예외일이 없습니다.") }}</div>
    </div>
</template>

<script>
import ExceptionCalendar from "../ExceptionCalendar.vue";
import { formatDate } from "../../utils/scheduleFormat";

export default {
    components: { ExceptionCalendar },
    props: {
        detail: { type: Object, required: true },
    },
    computed: {
        sortedExceptions() {
            return [...(this.detail.exceptConfig || [])].sort((a, b) => new Date(a.exceptDt) - new Date(b.exceptDt));
        },
    },
    methods: {
        formatDate,
    },
};
</script>
